export default "__VITE_ASSET__755414ff__"